module.exports = __webpack_public_path__ + "img/54.0a0d4f52.jpg";